import { REP_NAR} from "../../Data/typeDirs"
import { genId } from "../../utils"



export class ReportNarrative{

  constructor(data = {}){
    this._id = data._id || genId()
    this._reports_v2 = data._reports_v2
    this._report_blocks = data._report_blocks
    this.created = data.created || Date.now()
    this.modified = data.modified
    this._createdBy = data._createdBy 
    this._modifiedBy = data._modifiedBy
    this.type = ReportNarrative.getTypeDir()
    this.content = data.content ||''
    this.isForExport = data.isForExport
  }

  static createDefaultReportNarrative(reportId, reportBlockId){
   
    return new ReportNarrative({
      _reports_v2:reportId,
      _report_blocks:reportBlockId,
      
    })
  }

  static getTypeDir() { return REP_NAR }
  static getIndices() { return '_id,_reports_v2,_report_blocks' }


}